import { get,post } from "../Config";


export function PostRequestOTP({ data }) {
  return post({ url: `/api/impact/v1/requestOTP`, data });
}
export function PostVerifyOTP({ data = {} }) {
  return post({ url: `/api/impact/v1/verifyOTP`, data });
}